import { Action, Dispatch } from 'redux';
import { IAppState } from './reducers';
import { IVaultTeam, getAllTimeoutTeams } from '../api/vault/teams';

export interface IState {
     teams: IVaultTeam[],
     isLoading: boolean,
     isOpen: boolean,
}

export enum ActionType {
  ClearTimeoutTeams = 'TimeoutTeams.ClearTimeoutTeams',
  GetTimeoutTeams = 'TimeoutTeams.GetTimeoutTeams',
  IsTimeoutLoading = 'TimeoutTeams.IsTimeoutLoading',
  ToggleTimeoutTeams = 'TimeoutTeams.ToggleTimeoutTeams',
}

export interface ITimeoutTeamsPayload extends Action<ActionType> {
    payload?: IVaultTeam[]
}
const INITIAL_STATE: IState = {
  teams: null,
  isLoading: false,
  isOpen: false,
};

export default function reducer(state: IState = INITIAL_STATE, action: ITimeoutTeamsPayload): IState {
  switch (action.type) {
    case ActionType.GetTimeoutTeams:
      return {
        ...state,
        isLoading: false,
        teams: action.payload,
      };
    case ActionType.ClearTimeoutTeams:
      return INITIAL_STATE;
    case ActionType.ToggleTimeoutTeams:
      return {
        ...state,
        isOpen: true,
        isLoading: true,
      };
    default:
      return state;
  }
}

export const clearTimeoutTeams = () => ({
  type: ActionType.ClearTimeoutTeams,
});

export const toggleTimeoutTeams = () => async (
  dispatch: Dispatch<ITimeoutTeamsPayload>,
  getState: () => IAppState,
) => {
  const { timeoutTeams: { isOpen } } = getState();
  if (isOpen) {
    dispatch({
      type: ActionType.ClearTimeoutTeams,
    });
  } else {
    dispatch({
      type: ActionType.ToggleTimeoutTeams,
    });

    const response = await getAllTimeoutTeams();
    const newTimeoutTeams = response.data.data;
    if (newTimeoutTeams) {
      dispatch({
        payload: newTimeoutTeams,
        type: ActionType.GetTimeoutTeams,
      });
    }
  }
};
